import React, { useRef, useState, useEffect, forwardRef } from "react";
import { Document, Page, pdfjs } from "react-pdf";

const maxHeight = 200;
// const pdfTypeList = ["OCT_G", "OCT_M", "AL", "VF"]
const imageSize = {'OCT_G': [{width: 135, height: 135}], 'OCT_M': [{width: 390, height: 390}, {width: 293, height: 213}], 'AL': [], 'VF': [{width:24, height: 24}]};
const VFformat = [10,14,18,20,22,24,24,26,26,28,28,28,28,28,28,28,28,28,28,26,26,24,24,22,20,18,14,10];
const VFdiameter = 28;

const getFileType = async(texts) => {
    // console.log(texts)
    if("IOL CALCULATION" === texts[0].str) {
		return 'IOL';
	}
	else if("Patient:" === texts[0].str) {
		return 'VF';
	}
	else {
		for(let item of texts) {
			if(item.str.includes("ONH and RNFL OU")) {
				return 'OCT_G';
			}
			if(item.str.includes("Macula Thickness")) {
				return 'OCT_M';
			}
		}
	}
	return 'unknown';
}

const getImages = async(PDFdata, pageNum = 1) => {
    const PDF = await pdfjs.getDocument( {data:PDFdata} ).promise;
    let allImages = [];

    const page = await PDF.getPage(pageNum);
    const operatorList = await page.getOperatorList();
    const textContent = await page.getTextContent();
    const fileType = await getFileType(textContent.items);
    // console.log(fileType)

    operatorList.fnArray.forEach((fn, index) => {
        if (fn === pdfjs.OPS.paintImageXObject) {
            const image = operatorList.argsArray[index];

            for(let rect of imageSize[fileType]){
                if(image[1]===rect.width && image[2]===rect.height){
                    const img = page.objs.get(image[0]);
                    const imageData = {
                        img: img,
                        width: image[1],
                        height: image[2],
                        default_name: `${fileType}_${image[0]}`,
                        fileType: fileType
                    }
                    allImages.push(imageData);
                    break;
                }
            }
        }
    });

    if(fileType==='VF'){
        allImages = await restoreVFImage(allImages);
    }

    console.log(allImages)
    return(allImages);
}

const restoreVFImage = async(images) => {
    // console.log(images)
    const pixelWidth = imageSize.VF[0].width;
    const pixelHeight = imageSize.VF[0].height;

    const canvas = document.createElement('canvas');
    canvas.width = VFdiameter * pixelWidth;
    canvas.height = VFdiameter * pixelHeight;
    const ctx = canvas.getContext('2d');
    
    let inlineCounter = 0;
    let lineNo = 0;

    for(const imageInfo of images){
        const offsetX = pixelWidth * ((VFdiameter - VFformat[lineNo])/2 + inlineCounter);
        const offsetY = pixelHeight * lineNo;
        ctx.drawImage(imageInfo.img.bitmap, offsetX, offsetY, pixelWidth, pixelHeight);
        inlineCounter++;
        if(inlineCounter>=VFformat[lineNo]){
            inlineCounter = 0;
            lineNo++;
        }
        if(lineNo >= VFformat.length){
            break;
        }
    }

    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const returnImage = {
        img: imageData,
        width: canvas.width,
        height: canvas.height,
        default_name: `VF_image`,
        fileType: 'VF'
    }
    return [returnImage];
}

const DisplayImage = forwardRef(({imageData}, ref) => {
    const canvasRef = useRef(null);
    
    useEffect(() => {
        if (imageData && imageData.img) {
            const scale = maxHeight / imageData.height;

            const canvas = canvasRef.current;
            const ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            
            if(imageData.fileType==='VF'){
                const canvasTarget = imageData.img;

                const tempCanvas = document.createElement('canvas');
                tempCanvas.width = canvasTarget.width;
                tempCanvas.height = canvasTarget.height;
                const tempCtx = tempCanvas.getContext('2d');

                tempCtx.putImageData(canvasTarget, 0, 0);

                ctx.drawImage(tempCanvas, 0, 0, scale*canvasTarget.width, maxHeight);
            }
            else{
                const canvasTarget = imageData.img.bitmap;
                ctx.drawImage(canvasTarget, 0, 0, scale*canvasTarget.width, maxHeight);
            }
        }
    }, [imageData]);

    useEffect(() => {
        if(ref) ref(canvasRef.current);
    }, [ref])

    return (
        <canvas ref={canvasRef} width={maxHeight/imageData.height*imageData.width} height={maxHeight}/>
    );
})

const AddImageFromPDF = ({ onClose })=>{
    const [originFile, setOriginFile] = useState(null);
    const [errorMSG, setErrorMSG] = useState("");
    const [images, setImages] = useState([]);

    const fileRef = useRef(null);
    const canvasRefs = useRef([]);
    const checkboxRefs = useRef([]);

    const initializeHooks = () => {
        setOriginFile(fileRef.current.files[0]);
        setImages([]);
        setErrorMSG("");
    }

    const getPDFImage = async() => {
        const PDFfile = fileRef.current.files[0];

        if(PDFfile && PDFfile.type === "application/pdf"){
            try{
                const fileReader = new FileReader();
                fileReader.onload = async(e) => {
                    const fileUint8Array = new Uint8Array(e.target.result);
                    let returnImg = await getImages(fileUint8Array);
                    setImages(returnImg)
                }
                fileReader.readAsArrayBuffer(PDFfile);
            }
            catch(error){
                console.log("error when readong file:",error);
            }
        }
        else{
            setErrorMSG("no file");
        }
    }

    const pickReturnFile = async() => {
        let checkedFile = [];
        for (let i = 0; i < images.length; i++) {
            const canvas = canvasRefs.current[i];
            if (canvas && checkboxRefs.current[i].checked) {
                const base64Image = canvas.toDataURL('image/png');
                checkedFile.push(
                    {
                        default_name: images[i].default_name,
                        url: base64Image,
                        fileType: images[i].fileType
                    }
                );
            }
        }
        return checkedFile;
    }

    const returnAndClose = async() => {
        const returnFiles = await pickReturnFile();
        onClose(returnFiles);
    }

    return (
        <div>
            <div className=" flex">
                <input type="file" accept=".pdf" ref={fileRef} className="px-2" onChange={(event) => {initializeHooks()}}></input>
                {originFile ? <button onClick={(event) => getPDFImage()}>取出圖片</button> : <></>}
                {images.length>0 ? <button className=" pl-4" onClick={(event) => {returnAndClose()}}>加入到待上傳</button> : <></>}
                <div className=" text-xl pl-2">{errorMSG}</div>

            </div>
            <div className="flex">
                {
                    originFile ? 
                    <Document 
                        file={originFile}
                    >
                        <Page pageNumber={1} scale={0.7}/>
                    </Document>
                     : <></>
                }
                <div>
                    {
                        images.length > 0? 
                        (          
                            images.map((image, index)=>{
                                return(
                                    <div className=" w-auto h-auto flex">
                                        <input type="checkbox" ref={(el) => checkboxRefs.current[index] = el} defaultChecked={true} className=" absolute"></input>
                                        <DisplayImage key={index} imageData={image} ref={(el) => canvasRefs.current[index] = el}/>
                                        {/* <h4>{image.default_name}</h4> */}
                                    </div>
                                )
                            })
                        )
                        : <></>
                    }
                </div>
            </div>
        </div>
    );
}

export default AddImageFromPDF;
